import { jsx as _jsx } from "react/jsx-runtime";
const TextContent = ({ content, html }) => {
    return html ? (_jsx("div", { className: 'text-content', dangerouslySetInnerHTML: { __html: content } })) : (_jsx("div", { className: 'text-content', children: content }));
};
export default TextContent;
